import { render, staticRenderFns } from "./addCompany.vue?vue&type=template&id=0c44ae91&scoped=true&"
import script from "./addCompany.vue?vue&type=script&lang=js&"
export * from "./addCompany.vue?vue&type=script&lang=js&"
import style0 from "./addCompany.vue?vue&type=style&index=0&id=0c44ae91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44ae91",
  null
  
)

export default component.exports